// src/api/contactApi.js
import axiosInstance from "./axiosInstance";

const contactApi = {
  requestDemo: (payload) => {
    // Controller route:
    // POST /api/contact/request-demo
    // With axiosInstance baseURL likely set to "/api", this becomes:
    // POST /contact/request-demo
    return axiosInstance.post("/contact/request-demo", payload, {
      headers: { "Content-Type": "application/json" },
    });
  },
};

export default contactApi;
